<template>
  <div class="brand-group" @click="emitClick">
<!--    <suite-logo v-if="props.logo" :logo="props.logo" />-->
    <ion-title class="page-title title">{{ props.title }}</ion-title>
  </div>
</template>

<script setup lang="ts">
import {
  IonTitle,
  IonIcon
} from '@ionic/vue';
import {computed} from "vue";
import SuiteLogo from "@/components/SuiteLogo.vue";
import {Logo} from "@/models/settings.ts";


const props = defineProps<{
  logo?: Logo;
  title: string;
}>();


const emit = defineEmits<{(e: 'click'): void}>();

const emitClick = () => {
  emit('click');
};

</script>

<style scoped>
.brand-group {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-inline-start: 4px;
  cursor: pointer;
}

.page-title {
  font-size: 1.3rem;
  color: #363131;
  width: unset;
  position: unset;
  padding: 0;
}
</style>